import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseResponse } from '../../shared/models/base-api-response.interface';
import { endpoint, httpOptions } from '../../shared/apis/endpoint';
import { map } from 'rxjs/operators';
import { Login } from '../models/login.interface';
import { RegisterPaciente } from '../models/register.interface'
import { environment as env } from '../../../environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private user: BehaviorSubject<string>;

  public get userToken(): string {
    return this.user.value;
  }

  constructor(
    private http: HttpClient) {
    this.user = new BehaviorSubject<string>(
      JSON.parse(localStorage.getItem('token'))
    )
  }

  login(req: Login): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.LOGIN}`
    return this.http.post<BaseResponse>(requestUrl, req, httpOptions).pipe(
      map((resp: BaseResponse) => {
        if (resp.isSuccess) {
          localStorage.setItem('token', JSON.stringify(resp.data))
          this.user.next(resp.data)
        }
        else {
          Swal.fire({
            title: "Login",
            text: resp.message,
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        }
        return resp;
      })
    )
  }

  logout() {
    localStorage.removeItem('token');
    this.user.next(null);
    window.location.reload();
  }

  resetPassword(nrodoc: number) {
    const requestUrl = `${env.api}${endpoint.RESET_PASSWORD}${nrodoc}`
    return this.http.get<BaseResponse>(requestUrl, httpOptions).pipe(
      map((resp: BaseResponse) => {
        if (resp.isSuccess) {
          Swal.fire({
            title: "Operación exitosa",
            text: resp.message,
            icon: "success",
            confirmButtonText: "Aceptar"
          });
        }
        else {
          Swal.fire({
            title: "Operación fallida",
            text: resp.message,
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        }
        return resp;
      })
    )
  }

  forgotMail(nrodoc: number) {
    const requestUrl = `${env.api}${endpoint.FORGOT_MAIL}${nrodoc}`
    return this.http.get<BaseResponse>(requestUrl, httpOptions).pipe(
      map((resp: BaseResponse) => {
        if (resp.isSuccess) {
          Swal.fire({
            title: "Operación exitosa",
            text: resp.message,
            icon: "success",
            confirmButtonText: "Aceptar"
          });
        }
        else {
          Swal.fire({
            title: "Operación fallida",
            text: resp.message,
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        }
        return resp;
      })
    )
  }

  register(req: RegisterPaciente): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.REGISTER}`
    return this.http.post<BaseResponse>(requestUrl, req, httpOptions).pipe(
      map((resp: BaseResponse) => {
        if (resp.isSuccess) {
          Swal.fire({
            title: "Registro de paciente",
            text: resp.message,
            icon: "success",
            confirmButtonText: "Aceptar"
          });
        }
        else {
          Swal.fire({
            title: "Registro de paciente",
            text: resp.message,
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        }
        return resp;
      })
    )
  }

  verificarCodigo(nroDocumento: number, codigo: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CODIGO_NRODOC}${nroDocumento}${endpoint.CODIGO_CODIGO}${codigo}`
    return this.http.get(requestUrl, httpOptions).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

  changePassword(nroDocumento: number, password: string): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CHANGE_PASSWORD}${nroDocumento}${endpoint.CHANGE_PASSWORD2}${password}`
    return this.http.put(requestUrl, httpOptions).pipe(
      map((resp: BaseResponse) => {
        return resp
      })
    )
  }

  changeEmail(nroDocumento: number, email: string): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CHANGE_EMAIL}${nroDocumento}${endpoint.CHANGE_EMAIL2}${email}`
    return this.http.put(requestUrl, httpOptions).pipe(
      map((resp: BaseResponse) => {
        return resp
      })
    )
  }

  changeUsername(nroDocumento: number, username: string): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CHANGE_USERNAME}${nroDocumento}${endpoint.CHANGE_USERNAME2}${username}`
    return this.http.put(requestUrl, httpOptions).pipe(
      map((resp: BaseResponse) => {
        return resp
      })
    )
  }

  isTokenExpired(token: string): boolean {
    const tokenData = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = new Date(tokenData.exp * 1000);
    const currentTime = new Date();
    return expirationTime <= currentTime;
  }

}
